<template>
    <div class="app-main__inner">
        <div class="absolute bg-red-30 inset-0" style="z-index:9" @click="showFilter = false" v-if="showFilter"></div>
        <div class="container mb-3 dm-sans-font">
            <div class="row">
                <div class="col-md-12 mt-2 flex justify-center md:justify-end mb-4 bg-white border rounded-md p-2">
                    <div class="flex flex-col md:flex-row justify-between align-items-center space-x-4">
                        <span class="mb-2 md:mb-0 cursor-pointer">
                            <span @click="showFilter = !showFilter" class="flex justify-between align-items-center space-x-4 bg-gray-200 border px-3 py-2 rounded-md">
                                <span><img src="./../../assets/images/icons/Frame.png" alt=""></span>
                                <span class="text-gray-500">{{ $t('filter') }}</span>
                            </span>
                            <div class="absolute w-60 bg-white rounded border shadow-lg md:-ml-20" style="z-index:99" v-if="showFilter">
                                <FilterProductComponent  @hideAdvanceFilter="showFilter = false"
                                    @filterSupplier='filterSupplier' 
                                    @filterWebshopPrice='filterWebshopPrice'
                                    @filterStockQuantity='filterStockQuantity'
                                    @resetProduct='getWebshopProducts($route.params.id)'
                                />
                            </div>
                        </span>
                        <span class="mb-2 md:mb-0">
                            <input type="text" @input="searchInputTrigger" class="flex justify-between align-items-center space-x-4 focus:outline-none bg-gray-200 border px-3 py-2 rounded-md text-gray-500" v-bind:placeholder="$t('search')">
                        </span>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 mt-4">
                    <div class="table-responsive rounded-lg bg-white border">
                        <div class="col-md-12 flex justify-center" v-if="loading">
                            <svg class="animate-spin mr-2 h-8 w-8 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div>
                        <table style="width: 100%;" id="exampledestroy" class="table table-hover table-bordered">
                            <thead>
                                <tr class="bg-white rounded p-1 border-b-2 shadow-sm"> <!--class="w-full flex justify-between bg-white rounded p-1 shadow-sm"-->
                                    <th class="text-xs"><input type="checkbox" name="bx"></th>
                                    <th class="text-xs" width='100px'><div class="d-flex justify-content-between align-items-center">SKU<span class="flex flex-col"><i @click="sortAscProductSKU" class="lnr-chevron-up cursor-pointer small"></i><i @click="sortDescProductSKU" class="lnr-chevron-down cursor-pointer small"></i></span></div></th>
                                    <th class="text-xs" width='100px'><div class="d-flex justify-content-between align-items-center">{{ $t('quantity') }}<span class="flex flex-col"><i @click="sortAscProductQty" class="lnr-chevron-up cursor-pointer small"></i><i @click="sortDescProductQty" class="lnr-chevron-down cursor-pointer small"></i></span></div></th>
                                    <th class="text-xs" width='100px'><div class="d-flex justify-content-between align-items-center">{{ $t('name') }}<span class="flex flex-col"><i @click="sortAscProductName" class="lnr-chevron-up cursor-pointer small"></i><i @click="sortDescProductName" class="lnr-chevron-down cursor-pointer small"></i></span></div></th>
                                    <th class="text-xs"><div class="d-flex justify-content-between">{{ $t('supplierMatch') }}<span></span></div></th>
                                    <th class="text-xs" width='100px'><div class="d-flex justify-content-between align-items-center">{{ $t('supplierQuantity') }}<span class="flex flex-col"><i @click="sortAscSupplyQty" class="lnr-chevron-up cursor-pointer small"></i><i @click="sortDescSupplyQty" class="lnr-chevron-down cursor-pointer small"></i></span></div></th>
                                    

                                    <!-- <th class="text-xs"><div class="d-flex justify-content-between">SKU<span></span></div></th> -->
                                    <!-- <th class="text-xs"><div class="d-flex justify-content-between">{{ $t('quantity') }}<span></span></div></th> -->
                                    <!-- <th class="text-xs"><div class="d-flex justify-content-between">{{ $t('name') }}<span></span></div></th> -->
                                    <!-- <th class="text-xs"><div class="d-flex justify-content-between">{{ $t('supplierQuantity') }}<span></span></div></th> -->
                                    <th class="text-xs"><div class="d-flex justify-content-between">{{ $t('status')}}<span></span></div></th>
                                    <th class="text-xs"><div class="d-flex justify-content-between">{{ $t('action') }}<span></span></div></th>
                                </tr>
                            </thead>
                            <tbody v-for="product in GET_WEBSHOP_PRODUCTS.data" :key="product.id">
                                <tr class="bg-white rounded p-1 shadow-sm">
                                    <td><input type="checkbox" name="bx"></td>
                                    <td>{{ product.sku }}</td>
                                    <td>{{ product.stock_quantity }}</td>
                                    <td>{{ product.name }}</td>
                                    <td>{{ product.supplier_match }}</td>
                                    <td>{{ product.supplier_quantity }}</td>
                                    <td>
                                        <button class="bg-yellow-500 px-3 rounded text-white">{{ product.status | removeDasheSpace }}</button>
                                    </td>
                                    <td>
                                        <div class="flex justify-between space-x-3">
                                            <span class="flex justify-center align-items-center h-7 w-7 rounded-full bg-blue-900 cursor-pointer">
                                            <img src="./../../assets/images/icons/view.png" alt="">
                                            </span>
                                            <span class="flex justify-center align-items-center h-7 w-7 rounded-full bg-yellow-500 cursor-pointer">
                                                <img src="./../../assets/images/icons/logout.png" alt="">
                                            </span>
                                            <span class="flex justify-center align-items-center h-7 w-7 rounded-full bg-green-500 cursor-pointer">
                                                <img src="./../../assets/images/icons/correct.png" alt="">
                                            </span> 
                                            <!-- <span class="cursor-pointer">
                                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M21.2565 10.962C21.7305 11.582 21.7305 12.419 21.2565 13.038C19.7635 14.987 16.1815 19 11.9995 19C7.81752 19 4.23552 14.987 2.74252 13.038C2.51191 12.7411 2.38672 12.3759 2.38672 12C2.38672 11.6241 2.51191 11.2589 2.74252 10.962C4.23552 9.013 7.81752 5 11.9995 5C16.1815 5 19.7635 9.013 21.2565 10.962V10.962Z" stroke="#CA8D17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="#CA8D17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </span>
                                            <span class="cursor-pointer">
                                                <svg width="20" height="20" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.2041 5.88436e-09C10.4664 -7.42213e-05 8.79278 0.702098 7.51767 1.96615C6.24256 3.23021 5.45995 4.96301 5.32629 6.81818H5.04082C4.37885 6.81818 3.72336 6.9578 3.11178 7.22906C2.5002 7.50032 1.9445 7.89791 1.47642 8.39914C1.00834 8.90036 0.637034 9.49541 0.383709 10.1503C0.130384 10.8052 0 11.5071 0 12.2159C0 12.9247 0.130384 13.6266 0.383709 14.2815C0.637034 14.9364 1.00834 15.5315 1.47642 16.0327C1.9445 16.5339 2.5002 16.9315 3.11178 17.2028C3.72336 17.474 4.37885 17.6136 5.04082 17.6136H11.1429C11.143 15.9799 11.5816 14.3806 12.4065 13.0063C13.2314 11.6319 14.4078 10.5404 15.7956 9.8617C17.1835 9.18301 18.7242 8.94576 20.2344 9.17819C21.7446 9.41063 23.1606 10.103 24.3137 11.1727C24.0878 9.94578 23.4711 8.84086 22.569 8.04666C21.6669 7.25246 20.5352 6.81825 19.3673 6.81818H19.0819C18.9482 4.96301 18.1656 3.23021 16.8905 1.96615C15.6154 0.702098 13.9417 -7.42213e-05 12.2041 5.88436e-09ZM26 17.6136C26 19.5726 25.2733 21.4514 23.9796 22.8366C22.686 24.2218 20.9315 25 19.102 25C17.2726 25 15.5181 24.2218 14.2244 22.8366C12.9308 21.4514 12.2041 19.5726 12.2041 17.6136C12.2041 15.6547 12.9308 13.7759 14.2244 12.3907C15.5181 11.0055 17.2726 10.2273 19.102 10.2273C20.9315 10.2273 22.686 11.0055 23.9796 12.3907C25.2733 13.7759 26 15.6547 26 17.6136ZM23.192 14.3705C23.1427 14.3175 23.0842 14.2756 23.0197 14.2469C22.9552 14.2183 22.8861 14.2035 22.8163 14.2035C22.7465 14.2035 22.6774 14.2183 22.613 14.2469C22.5485 14.2756 22.4899 14.3175 22.4407 14.3705L17.5102 19.6511L15.7634 17.7795C15.7141 17.7267 15.6555 17.6848 15.5911 17.6562C15.5266 17.6276 15.4575 17.6129 15.3878 17.6129C15.318 17.6129 15.2489 17.6276 15.1844 17.6562C15.12 17.6848 15.0614 17.7267 15.0121 17.7795C14.9627 17.8324 14.9236 17.8951 14.8969 17.9641C14.8702 18.0331 14.8565 18.1071 14.8565 18.1818C14.8565 18.2565 14.8702 18.3305 14.8969 18.3995C14.9236 18.4685 14.9627 18.5313 15.0121 18.5841L17.1345 20.8568C17.1838 20.9097 17.2424 20.9517 17.3068 20.9804C17.3713 21.009 17.4404 21.0237 17.5102 21.0237C17.58 21.0237 17.6491 21.009 17.7136 20.9804C17.778 20.9517 17.8366 20.9097 17.8859 20.8568L23.192 15.175C23.2414 15.1222 23.2806 15.0595 23.3074 14.9905C23.3341 14.9215 23.3479 14.8475 23.3479 14.7727C23.3479 14.698 23.3341 14.624 23.3074 14.555C23.2806 14.4859 23.2414 14.4232 23.192 14.3705Z" fill="#2BA1D3"/>
                                                </svg>
                                            </span>
                                            <span class="cursor-pointer">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M20.1334 16.659C18.5156 19.4388 15.5058 21.3131 12.0462 21.3202C9.56611 21.3174 7.18843 20.3347 5.4346 18.5878C3.68078 16.8408 2.69399 14.4722 2.69067 12.0013C2.69351 9.53021 3.68009 7.16111 5.43397 5.41375C7.18785 3.6664 9.5658 2.68349 12.0462 2.68066C15.5058 2.68691 18.5138 4.56033 20.1325 7.34011L23.6836 9.37962L23.8118 9.45284C22.6376 4.05045 17.8192 0.00178591 12.0462 0C5.39299 0.00178591 0.00179258 5.37292 0 12.0013C0.00268887 18.6271 5.39388 23.9982 12.0462 24C17.8201 23.9982 22.6403 19.9478 23.8118 14.5436L23.6863 14.6168L20.1334 16.659ZM24 12.0013L17.5915 8.31343V10.3654H7.75471V13.6337H17.5915V15.6857L24 12.0013Z" fill="#079336"/>
                                                </svg>
                                            </span> -->
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="flex flex-col md:flex-row justify-between mb-4">
                        <span class="flex justify-between align-items-center space-x-5 mt-4">
                            <span class="text-base">{{ $t('show') }}</span>
                            <span>
                                <select v-model="limit" class="form-select" @change="shopResultNumber">
                                    <option value="100" selected>100</option>
                                    <option value="200">200</option>
                                    <option value="400">400</option>
                                    <option value="500">500</option>
                                </select>
                            </span>
                        </span>
                        <div class="pagination-block" v-if="GET_WEBSHOP_PRODUCTS.data">
                            <paginate
                            :page-count="GET_WEBSHOP_PRODUCTS.total_pages"
                            :click-handler="changePageNumber"
                            prev-text="<"
                            next-text=">"
                            :container-class="'pagination space-x-2'">
                            </paginate>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Notification />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import FilterProductComponent from './component/FilterProductComponent.vue'
    import debounce from 'lodash.debounce'
    import Paginate from 'vuejs-paginate'

    export default {
        name : 'WebshopOverview',
        components : {
            Notification : () => import('./../../customComponent/NotificationAlert'),
            FilterProductComponent,
            paginate : Paginate,
        },
        data () {
            return {
                loading : true,
                showFilter : false,
                limit : 10
            }
        },
        computed : {
            ...mapGetters({
                GET_WEBSHOP_PRODUCTS : 'customer/GET_WEBSHOP_PRODUCTS'
            })
        },
        watch : {
            $route (to, from) {
                const { id } = to.params
                this.getWebshopProducts(parseInt(id), this.limit)
            }
        },
        mounted () {
            const { id } = this.$route.params
            if (id) {
                // const webshopId = id.split('-').splice(-1)[0].slice(0, -3)
                this.getWebshopProducts(parseInt(id), this.limit)
            }
        },
        methods : {
            searchInputTrigger : debounce(function (event) {
                if (event.target.value !== '') {
                    this.filterSearch(event)
                } else {
                    this.$store.commit('customer/FILTER_ALL_INTEGRATION_PRODUCT', null)
                }
            }, 500),
            changePageNumber (number) {
                const { id } = this.$route.params
                this.loading = true
                this.$store.dispatch('customer/getWebshopProducts', { page : this.$services.endpoints.WEBSHOP_PRODUCTS + `?page=${number}&web_shop_id=${id}&limit=${this.limit}` })
                .then(_ => {
                    this.loading = false
                }).catch((err) => {
                    if (err.response.status === 401) {
                        this.$store.commit('auth/CLEAR_AUTH_USER', null)
                        window.Bus.$emit('sign-out')
                    }
                })
            },
            filterSearch (event) {
                this.$store.commit('customer/FILTER_SEARCH_INTEGRATION_PRODUCT', { value : event.target.value })
            },
            getWebshopProducts (id, limit) {
                this.loading = true
                const payload = {
                    value : id,
                    limit
                }
                this.$store.dispatch('customer/getWebshopProducts', payload)
                .then(_ => {
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                    if (err.response.status === 401) {
                        this.$store.commit('auth/CLEAR_AUTH_CUS', null)
                        window.Bus.$emit('sign-out')
                    }
                })
            },
            filterSupplier (data) {
                this.loading = true
                const payload = {
                    query : `?company_name=${data.name}`
                }
                this.$store.dispatch('customer/filterWebshopProducts', payload)
                .then(_ => {
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                    if (err.response.status === 401) {
                        this.$store.commit('auth/CLEAR_AUTH_CUS', null)
                        window.Bus.$emit('sign-out')
                    }
                })
            },
            filterWebshopPrice (data) {
                if (parseFloat(data.amount) || parseFloat(data.start) || parseFloat(data.end)) {
                    this.loading = true
                    const payload = {}
                    if (data.range === 'between') {
                        payload.query = `?is_${data.range}=True&supplier_price=${data.start}&supplier_price_2=${data.end}` 
                    } else {
                        payload.query = `?is_${data.range}=True&supplier_price=${data.amount}` 
                    }
                    this.$store.dispatch('customer/filterWebshopProducts', payload)
                    .then(_ => {
                        this.loading = false
                    })
                    .catch(err => {
                        this.loading = false
                        if (err.response.status === 401) {
                            this.$store.commit('auth/CLEAR_AUTH_CUS', null)
                            window.Bus.$emit('sign-out')
                        }
                    })
                }
            },
            filterStockQuantity (data) {
                if (parseInt(data.value)) {
                    this.loading = true
                    const payload = {
                        query : `?stock_quantity=${data.value}`
                    }
                    this.$store.dispatch('customer/filterWebshopProducts', payload)
                    .then(_ => {
                        this.loading = false
                    })
                    .catch(err => {
                        this.loading = false
                        if (err.response.status === 401) {
                            this.$store.commit('auth/CLEAR_AUTH_CUS', null)
                            window.Bus.$emit('sign-out')
                        }
                    })
                }
            },
            sortAscProductSKU () {
                this.$store.commit('customer/SORT_PRODUCT_SKU_ASC')
            },
            sortDescProductSKU () {
                this.$store.commit('customer/SORT_PRODUCT_SKU_DESC')
            },
            sortAscProductQty () {
                this.$store.commit('customer/SORT_PRODUCT_QTY_ASC')
            },
            sortDescProductQty () {
                this.$store.commit('customer/SORT_PRODUCT_QTY_DESC')
            },
            sortAscProductName () {
                this.$store.commit('customer/SORT_PRODUCT_NAME_ASC')
            },
            sortDescProductName () {
                this.$store.commit('customer/SORT_PRODUCT_NAME_DESC')
            },
            sortAscSupplyQty () {
                this.$store.commit('customer/SORT_PRODUCT_SUPPLY_QTY_ASC')
            },
            sortDescSupplyQty () {
                this.$store.commit('customer/SORT_PRODUCT_SUPPLY_QTY_DESC')
            },
            shopResultNumber (e) {
                const { id } = this.$route.params
                this.limit = parseInt(e.target.value)
                this.getWebshopProducts(id, parseInt(e.target.value))
            },
        }
    }
</script>

<style lang="scss" scoped>
@import "./../../assets/variables.scss";
.c-border{
    border-width: 1px !important;
}
.form-control{
    border: 1px solid $form-border !important;
    height: unset !important;
    padding: .175rem .75rem !important;
}
.form-select{
    // border: 1px solid $form-border !important;
    height: unset !important;
    padding: .175rem 1.5rem !important;
}
.form-control:focus{
    box-shadow: unset !important;
    border: 1px solid $theme-primary-color !important;
}
.btn-border-all{
    border: 1px solid $theme-secondary-color !important;
    color: $theme-secondary-color !important;
}
.table tbody tr > td{
    // padding: 0.1rem 0.55rem !important;
    font-size: 12px !important;
    text-align: left;
    color: #6F6F6F;
}
</style>